const Roles = {
    user: 'User',
    admin: 'Admin'
}

export default Roles;